<template>
  <SegmentControl
    v-model="valueModel"
    class="mb-2"
    :label="label"
    name="tournamentPlayersType"
    :options="variants"
  />
</template>

<script>
import { emptyString } from '@/utils/factories';
import valueModel from '@/mixins/valueModel';
import SegmentControl from '@/components/atoms/form/HeraFormSegmentControl';

export default {
  components: {
    SegmentControl,
  },
  mixins: [valueModel],

  props: {
    value: {
      type: String,
      default: emptyString,
    },
    label: {
      type: String,
      default: emptyString,
    },
  },
  computed: {
    variants() {
      return [
        {
          label: this.$t(
            '_web_competitions_tournaments-players-type-all',
            'All'
          ),
          value: null,
        },
        {
          label: this.$t(
            '_web_competitions_tournaments-players-type-single',
            'Single'
          ),
          value: 'profile',
        },
        {
          label: this.$t(
            '_web_competitions_tournaments-players-type-team',
            'Team'
          ),
          value: 'clan',
        },
      ];
    },
  },
};
</script>
